// vms-mount-fit.js: pure TV-to-mount fit rules for the find-mounts page. Notes: assets/vms-find-mounts.notes.md
(function (root) {
  'use strict';
  var STD = [75, 100, 200, 300, 400, 500, 600, 800];
  var LB = 2.20462;
  var PARTS = ['Mounting head', 'Adapter / VESA plate', 'Ceiling plate', 'Mount accessory'];
  var WHY = { vesa: 'holes', no_vesa_data: 'holes', size: 'size', no_size_data: 'size', weight: 'weight', no_rating: 'weight' };
  var SUBS = ['ceiling_kit', 'foldup', 'dental', 'fixed', 'tilt', 'full_motion', 'two_tv'];
  var RAILS_ALWAYS_71_75 = true;
  var RAILS_MOUNT_SKU = '33FD001';
  var RAILS_REACH_MM = 662;
  var RAILS_MAX_IN = 75;
  var RAILS_HANDLE = '33fd-adapt-adapter-rails-for-33fd001';

  function isNum(v) { return typeof v === 'number' ? isFinite(v) : (typeof v === 'string' && /^\d+(\.\d+)?$/.test(v.trim())); }
  function num(v) { return isNum(v) ? Number(v) : null; }
  function pos(v) { var n = num(v); return n != null && n > 0 ? n : null; }
  function list(v) { return Array.isArray(v) ? v : (typeof v === 'string' && v ? [v] : []); }
  function has(a, s) { return list(a).indexOf(s) !== -1; }

  function snapVesa(mm) {
    if (!isNum(mm)) return null;
    mm = Number(mm);
    var best = null, bd = Infinity;
    for (var i = 0; i < STD.length; i++) { var d = Math.abs(mm - STD[i]); if (d < bd) { bd = d; best = STD[i]; } }
    return bd <= 13 ? best : Math.round(mm);
  }

  function parseVesa(s) {
    var m = /^\s*(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*$/i.exec(String(s == null ? '' : s));
    if (!m) return null;
    var w = Number(m[1]), h = Number(m[2]);
    return w > 0 && h > 0 ? { w: w, h: h } : null;
  }

  function measRead(raw, th) {
    var t = String(raw == null ? '' : raw).trim();
    if (t === '') return { value: null, invalid: false };
    var n = /^\d+(\.\d+)?$/.test(t) ? Number(t) : NaN;
    if (!isFinite(n) || n <= 0) return { value: null, invalid: true };
    return { value: n >= th ? n / 25.4 : n, invalid: false };
  }
  function measOk(a, b, c) { return a.value != null && b.value != null && c.value != null && b.value + c.value < a.value; }
  function nice(x) { var v = Math.round(x * 10) / 10; return v % 1 === 0 ? String(Math.round(v)) : v.toFixed(1); }
  function sizeParam(v) { var n = pos(v); return n == null ? null : Math.round(n); }

  function blank(source) {
    return { source: source, state: 'ok', model: null, manufacturer: null, series: null, sizeIn: null, rowSize: null, sizeOverride: false,
      vesaW: null, vesaH: null, weightLb: null, weightKg: null, catalogVersion: null, iface: null, a: null, b: null, c: null, fromTopMm: null };
  }

  function tvFromRow(row, opt) {
    row = row || {}; opt = opt || {};
    var tv = blank('catalog');
    var st = row.lookup_status, w = pos(row.vesa_width_mm), h = pos(row.vesa_height_mm);
    tv.state = st === 'proprietary_mount' ? 'proprietary' : (st === 'vesa_known' && w != null && h != null) ? 'ok' : 'no_vesa';
    tv.model = row.model_number == null ? null : String(row.model_number);
    tv.manufacturer = row.manufacturer == null || row.manufacturer === '' ? null : String(row.manufacturer);
    tv.series = row.series == null || row.series === '' ? null : String(row.series);
    tv.iface = row.proprietary_interface == null || row.proprietary_interface === '' ? null : String(row.proprietary_interface);
    tv.rowSize = sizeParam(row.screen_size_in);
    var over = sizeParam(opt.size);
    tv.sizeIn = over != null ? over : tv.rowSize;
    tv.sizeOverride = over != null && tv.rowSize != null && over !== tv.rowSize;
    if (tv.state === 'ok') { tv.vesaW = w; tv.vesaH = h; tv.fromTopMm = pos(row.vesa_from_top_mm); }
    var kg = pos(row.weight_kg);
    if (kg != null) { tv.weightKg = kg; tv.weightLb = kg * LB; }
    var cv = opt.catalogVersion != null ? opt.catalogVersion : row.catalog_version;
    tv.catalogVersion = cv == null || cv === '' ? null : String(cv);
    return tv;
  }

  function getter(p) {
    if (p && typeof p.get === 'function') return function (k) { return p.get(k); };
    if (typeof p === 'string') { var u = new URLSearchParams(p); return function (k) { return u.get(k); }; }
    p = p || {};
    return function (k) { return p[k] == null ? null : String(p[k]); };
  }

  function tvFromParams(params) {
    var g = getter(params);
    var a = measRead(g('tva'), 100), b = measRead(g('tvb'), 50), c = measRead(g('tvc'), 50);
    var size = sizeParam(g('size'));
    var tv;
    if (measOk(a, b, c)) {
      tv = blank('manual');
      tv.a = a.value; tv.b = b.value; tv.c = c.value; tv.sizeIn = size;
      return tv;
    }
    var v = parseVesa(g('vesa'));
    if (size == null && !v) return null;
    tv = blank('hand');
    tv.sizeIn = size;
    if (v) { tv.vesaW = v.w; tv.vesaH = v.h; }
    return tv;
  }

  function matchGroup(m) {
    m = m || {};
    for (var i = 0; i < PARTS.length; i++) if (has(m.type, PARTS[i])) return 'excluded';
    if (m.component_type === 'mounting_head') return 'excluded';
    if (has(m.type, 'Multi-screen mount')) return 'two_tv';
    return m.source === 'wall' ? 'wall' : 'ceiling';
  }

  function subType(m, group) {
    if (group === 'two_tv') return 'two_tv';
    if (group === 'ceiling') return has(m.type, 'Fold-down (flip-up)') ? 'foldup' : has(m.type, 'Dental operatory') ? 'dental' : 'ceiling_kit';
    if (group === 'wall') return has(m.adjustability, 'Full-motion') ? 'full_motion' : has(m.adjustability, 'Tilt') ? 'tilt' : 'fixed';
    return null;
  }

  function range(a, b) {
    a = num(a); b = num(b);
    if (a == null || b == null) return null;
    return a <= b ? [Math.round(a), Math.round(b)] : [Math.round(b), Math.round(a)];
  }

  function isRailsMount(m) {
    m = m || {};
    return String(m.sku == null ? '' : m.sku).toUpperCase() === RAILS_MOUNT_SKU || /^33fd001-/.test(String(m.handle || ''));
  }

  var RAILS_REACH_IN = Math.round(RAILS_REACH_MM / 25.4 * 10) / 10;

  function railsTotal(tv) {
    if (tv.source === 'manual' && tv.b != null && tv.c != null) {
      var inch = Math.round((tv.b + tv.c) * 10) / 10;
      return { mm: Math.round((tv.b + tv.c) * 254) / 10, inch: inch, over: inch > RAILS_REACH_IN, unit: 'in' };
    }
    if (tv.fromTopMm == null || tv.vesaH == null) return null;
    var mm = Math.round((tv.fromTopMm + tv.vesaH) * 100) / 100;
    return { mm: mm, inch: Math.round(mm / 25.4 * 10) / 10, over: mm > RAILS_REACH_MM, unit: 'mm' };
  }

  function applyRails(out, tv, hi) {
    var t = railsTotal(tv), ov = t ? t.over : null;
    var big = tv.sizeIn != null && tv.sizeIn > hi;
    var r = { needed: ov, free: tv.sizeIn == null ? null : !big, total_mm: t ? t.mm : null, total_in: t ? t.inch : null, unit: t ? t.unit : null, reach_mm: RAILS_REACH_MM, max_in: RAILS_MAX_IN, big: big };
    if (big && RAILS_ALWAYS_71_75) r.needed = true;
    out.rails = r;
    if (r.needed === true) {
      out.reason = r.free === true ? 'rails_free' : r.free === false ? 'rails_order' : 'rails';
      if (out.fit === 'fits') out.fit = 'fits_rails';
    } else if (r.needed === null) out.note = 'measure_rails';
  }

  function checkMount(tv, m) {
    tv = tv || blank('hand'); m = m || {};
    var group = matchGroup(m);
    var out = { group: group, sub: subType(m, group), fit: 'no', reason: null, checks: { vesa: null, weight: null, size: null } };
    if (group === 'excluded') { out.reason = 'part'; return out; }
    var wr = range(m.vesa_w_min, m.vesa_w_max), hr = range(m.vesa_h_min, m.vesa_h_max);
    var vk = tv.vesaW != null && tv.vesaH != null;
    var sw = vk ? snapVesa(tv.vesaW) : null, sh = vk ? snapVesa(tv.vesaH) : null;
    var vesa = { ok: null, tv: vk ? [tv.vesaW, tv.vesaH] : null, mount: wr && hr ? { w: wr, h: hr } : null };
    if (vk && wr && hr) vesa.ok = wr[0] <= sw && sw <= wr[1] && hr[0] <= sh && sh <= hr[1];
    var cap = num(m.weight_capacity_lb);
    var weight = { ok: null, tv: tv.weightLb, mount: cap };
    if (cap != null && tv.weightLb != null) weight.ok = Math.round(tv.weightLb) <= cap;
    var lo = num(m.screen_low), hi = num(m.screen_high), rails = isRailsMount(m) && hi != null;
    var top = rails ? Math.max(hi, RAILS_MAX_IN) : hi;
    var size = { ok: null, tv: tv.sizeIn, mount: lo != null && hi != null ? [lo, hi] : null };
    if (rails) size.railsMax = top;
    if (size.mount && tv.sizeIn != null) size.ok = lo <= tv.sizeIn && tv.sizeIn <= top;
    out.checks = { vesa: vesa, weight: weight, size: size };
    if (!vesa.mount) out.reason = 'no_vesa_data';
    else if (vesa.ok === false) out.reason = 'vesa';
    else if (cap == null) out.reason = 'no_rating';
    else if (weight.ok === false) out.reason = 'weight';
    else if (!size.mount) out.reason = 'no_size_data';
    else if (size.ok === false) out.reason = 'size';
    if (out.reason) return out;
    if (vesa.ok && size.ok) out.fit = weight.ok ? 'fits' : 'check_weight';
    else if (vesa.ok && size.ok === null) out.fit = weight.ok ? 'fits' : 'check_weight';
    else if (vesa.ok === null && size.ok) out.fit = 'size_only';
    else out.reason = 'no_input';
    if (rails && out.fit !== 'no') applyRails(out, tv, hi);
    return out;
  }

  function byPriority(items) {
    return items.map(function (x, i) { return [x, i]; }).sort(function (p, q) {
      var a = num(p[0].mount.priority), b = num(q[0].mount.priority);
      if (a == null && b == null) return p[1] - q[1];
      if (a == null) return 1;
      if (b == null) return -1;
      return a - b || p[1] - q[1];
    }).map(function (p) { return p[0]; });
  }

  function builderLink(tv, base) {
    var u = (base || '/pages/build-custom-tv-ceiling-mount') + '?size=' + tv.sizeIn;
    if (tv.source === 'catalog' && tv.model) return u + '&tvm=' + encodeURIComponent(tv.model);
    if (tv.source === 'manual') return u + '&tva=' + nice(tv.a) + '&tvb=' + nice(tv.b) + '&tvc=' + nice(tv.c);
    return u;
  }

  function pageParams(tv) {
    if (!tv) return [];
    var p = [];
    if (tv.source === 'catalog') { if (tv.model) p.push(['tvm', tv.model]); }
    else if (tv.source === 'manual') p.push(['tva', nice(tv.a)], ['tvb', nice(tv.b)], ['tvc', nice(tv.c)]);
    if (tv.sizeIn != null) p.push(['size', String(tv.sizeIn)]);
    if (tv.source === 'hand' && tv.vesaW != null) p.push(['vesa', nice(tv.vesaW) + 'x' + nice(tv.vesaH)]);
    return p;
  }

  function matchAll(tv, snap, opt) {
    opt = opt || {};
    var counts = { ceiling_kit: 0, foldup: 0, dental: 0, fixed: 0, tilt: 0, full_motion: 0, two_tv: 0, ceiling: 0, wall: 0, one_tv_total: 0 };
    var res = { state: 'need_input', tv: tv || null, groups: { ceiling: [], wall: [], two_tv: [] }, counts: counts, excluded: [], builder: { show: false, url: null, note: false } };
    if (!tv) return res;
    if (tv.state === 'proprietary') { res.state = 'proprietary'; return res; }
    var vk = tv.vesaW != null && tv.vesaH != null;
    var products = snap && Array.isArray(snap.products) ? snap.products : [];
    var cfgFit = false, seen = {}, why = { holes: 0, size: 0, weight: 0 };
    if (tv.state === 'ok' && (vk || tv.sizeIn != null)) {
      products.forEach(function (m) {
        if (!m || seen[m.handle]) return;
        seen[m.handle] = true;
        var r = checkMount(tv, m);
        if (r.fit === 'no') {
          res.excluded.push({ handle: m.handle, reason: r.reason });
          if (r.group === 'ceiling' || r.group === 'wall') { var f = WHY[r.reason]; if (f) why[f]++; }
          return;
        }
        r.handle = m.handle; r.mount = m;
        res.groups[r.group].push(r);
        counts[r.sub]++;
        if (r.group !== 'two_tv') { counts[r.group]++; counts.one_tv_total++; }
        if (r.group === 'ceiling' && m.component_type === 'configurable_mount' && (r.fit === 'fits' || r.fit === 'check_weight')) cfgFit = true;
      });
      res.groups.ceiling = byPriority(res.groups.ceiling);
      res.groups.two_tv = byPriority(res.groups.two_tv);
    }
    if (tv.state === 'no_vesa') res.state = 'no_vesa';
    else if (!vk && tv.sizeIn == null) res.state = 'need_input';
    else if (tv.sizeIn == null) res.state = 'need_size';
    else res.state = counts.one_tv_total ? 'result' : 'zero';
    if (res.state === 'zero') res.zeroReason = ['holes', 'size', 'weight'].reduce(function (a, b) { return why[b] > why[a] ? b : a; });
    var sizeOk = tv.sizeIn != null && tv.sizeIn >= 10 && tv.sizeIn <= 90;
    if (sizeOk && (!vk || cfgFit)) {
      res.builder.show = true;
      res.builder.url = builderLink(tv, opt.builderUrl);
      res.builder.note = tv.source === 'catalog' && tv.sizeOverride;
    }
    return res;
  }

  function expand(raw) {
    if (!raw || typeof raw !== 'object') return null;
    if (Array.isArray(raw.products)) return raw;
    if (!Array.isArray(raw.fields) || !Array.isArray(raw.rows)) return null;
    var out = {};
    for (var k in raw) if (Object.prototype.hasOwnProperty.call(raw, k) && k !== 'fields' && k !== 'rows') out[k] = raw[k];
    out.products = raw.rows.map(function (r) {
      var m = {};
      raw.fields.forEach(function (f, i) { m[f] = r[i] === undefined ? null : r[i]; });
      m.url = '/products/' + m.handle;
      return m;
    });
    return out;
  }

  function fmt(x) { var v = Math.round(Number(x) * 100) / 100; return String(v); }
  function lb1(x) { return Number(x).toFixed(1); }
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function vesaText(tv) { return fmt(tv.vesaW) + ' x ' + fmt(tv.vesaH) + ' mm'; }
  function callUs(phone) { return phone ? 'Call us at ' + phone : 'Call us'; }
  function tail(c, w) {
    if (c && w) return ': ' + plural(c, 'ceiling mount', 'ceiling mounts') + ' and ' + plural(w, 'wall mount', 'wall mounts') + '.';
    var kind = c ? 'ceiling' : 'wall';
    return (c + w) === 1 ? ', a ' + kind + ' mount.' : ', all of them ' + kind + ' mounts.';
  }

  function sentence(res) {
    var tv = res.tv, k = res.counts;
    if (!tv) return '';
    var vk = tv.vesaW != null && tv.vesaH != null, wk = tv.weightLb != null;
    var n = k.one_tv_total;
    if (res.state === 'need_size' && vk) {
      return 'These mounts take a TV with VESA ' + vesaText(tv) + (wk ? ' that weighs ' + lb1(tv.weightLb) + ' lb' : '') + '. Pick your screen size to check the size range too.';
    }
    if (res.state !== 'result') return '';
    if (!vk) {
      return (n === 1 ? 'This mount is made for a ' : 'These ' + n + ' mounts are made for a ') + tv.sizeIn + ' inch screen' + tail(k.ceiling, k.wall) + ' To check the hole pattern, enter both hole spacings below.';
    }
    var s = (n === 1 ? '1 mount fits' : n + ' mounts fit') + ' a TV with VESA ' + vesaText(tv) + (wk ? ' that weighs ' + lb1(tv.weightLb) + ' lb' : '') + tail(k.ceiling, k.wall);
    if (!wk) s += ' We do not have this TV\'s weight, so check it against each mount\'s rating.';
    return s;
  }

  function twoTvNote(res) {
    var n = res.counts.two_tv;
    if (!n || (res.state !== 'result' && res.state !== 'zero' && res.state !== 'need_size')) return '';
    return n === 1 ? '1 two-TV mount also takes this TV, one on each side. It is under Two TVs.'
      : n + ' two-TV mounts also take this TV, one on each side. They are under Two TVs.';
  }

  function fmtN(x) { return String(Math.round(Number(x) * 100) / 100); }
  function inch1(x) { return Number(x).toFixed(1); }
  function limit(x) { return x && x.unit === 'in' ? inch1(RAILS_REACH_IN) + ' inches' : RAILS_REACH_MM + ' mm (' + inch1(RAILS_REACH_IN) + ' inches)'; }
  function mmText(mm) { var v = Math.round(mm * 10) / 10; return String(mm > RAILS_REACH_MM && v <= RAILS_REACH_MM ? fmtN(mm) : v); }
  function fig(x) { return x.unit === 'in' ? inch1(x.total_in) + ' inches' : mmText(x.total_mm) + ' mm (' + inch1(x.total_in) + ' inches)'; }
  var RAILS_NAME = 'our 33FD-ADAPT adapter rails';
  var MEASURE = 'Measure from the top edge of your TV to the lower mounting holes';
  function dist(x) { return x.total_mm == null ? '' : 'The distance from its top edge to the lower mounting holes is ' + fig(x); }
  function over(x) { return dist(x) + ', more than the ' + limit(x) + ' this mount reaches'; }
  function inside(x) { return dist(x) + ', inside the ' + limit(x) + ' this mount reaches.'; }
  function bigWhy(x) { return x.big && RAILS_ALWAYS_71_75 ? 'TVs from 71 to ' + RAILS_MAX_IN + ' inches need them on this mount.' : over(x) + '.'; }
  function sizeRange(c) { return 'This mount takes screens from ' + fmt(c.size.mount[0]) + ' to ' + fmt(c.size.mount[1]) + ' inches, and ' + (Math.round(c.size.mount[1]) + 1) + ' to ' + RAILS_MAX_IN + ' inches with our adapter rails.'; }

  function railsLine(r) {
    var x = r.rails;
    if (x.needed === null) return MEASURE + '. Over ' + limit(x) + ' needs ' + RAILS_NAME + (x.free === false ? ', ordered separately.' : x.free === true ? ', which we include free.' : '.');
    if (x.needed === false) return inside(x);
    if (x.free === true) return over(x) + ', so it needs our adapter rails. We include them free with this mount.';
    if (x.free === false) return 'Needs ' + RAILS_NAME + ', ordered separately. ' + bigWhy(x);
    return over(x) + ', so it needs ' + RAILS_NAME + '. Pick the screen size above to finish the check.';
  }

  function railsVerdict(tv, r, phone) {
    if (!tv || tv.state !== 'ok' || !r || !r.checks || !r.checks.size || !r.checks.size.railsMax) return null;
    var c = r.checks, x = r.rails, out = { text: '', order: false, phone: false };
    if (r.fit === 'no') {
      if (r.reason !== 'size') return null;
      out.text = 'This TV does not fit this mount. It takes screens from ' + fmt(c.size.mount[0]) + ' to ' + fmt(c.size.mount[1]) + ' inches, and up to ' + RAILS_MAX_IN + ' inches with ' + RAILS_NAME + '. ' + callUs(phone) + ' and we can help you pick a mount.';
      out.phone = !!phone;
      return out;
    }
    if (x.free === null) {
      out.text = 'We don\'t have this TV\'s screen size. ' + sizeRange(c) + ' ' + (x.needed === null ? MEASURE + ': over ' + limit(x) + ' needs the rails.' : x.needed ? over(x) + ', so it needs the rails.' : inside(x)) + ' ' + callUs(phone) + ' and we will help.';
      out.phone = !!phone;
    }
    else if (x.needed === true && x.free === false) { out.text = 'This TV fits with ' + RAILS_NAME + '. ' + bigWhy(x); out.order = true; }
    else if (x.needed === true) out.text = 'This TV fits. ' + over(x) + ', so it needs our adapter rails. We include them free with your order.';
    else if (x.needed === null && x.free === false) { out.text = 'This TV fits. ' + MEASURE + ': if it is more than ' + limit(x) + ', it needs ' + RAILS_NAME + '.'; out.order = true; }
    else if (x.needed === null) { out.text = 'This TV fits. ' + MEASURE + ': if it is more than ' + limit(x) + ', it needs our adapter rails, and we include them free. ' + callUs(phone) + ' and we will add them to your order.'; out.phone = !!phone; }
    else out.text = 'This TV fits this mount. ' + inside(x);
    if (r.fit === 'check_weight') out.text += ' We do not have this TV\'s weight, so check it against this mount\'s ' + fmt(c.weight.mount) + ' lb rating.';
    return out;
  }

  function railsProperty(tv, r) {
    if (!tv || !r || r.reason !== 'rails_free' || !r.rails || r.rails.free !== true || r.rails.total_mm == null) return null;
    var name = ((tv.manufacturer ? tv.manufacturer + ' ' : '') + (tv.model || '')).trim();
    return 'Included free for TV ' + (name || 'from your measurements') + ' (' + mmText(r.rails.total_mm) + ' mm to lower holes)';
  }

  function railsUrl(tv) {
    var u = '/products/' + RAILS_HANDLE;
    return tv && tv.source === 'catalog' && tv.model ? u + '?tvm=' + encodeURIComponent(tv.model) : u;
  }

  function lines(r) {
    var c = r.checks, out = [];
    if (c.vesa.ok) out.push(fmt(c.vesa.tv[0]) + ' x ' + fmt(c.vesa.tv[1]) + ' mm is inside this mount\'s hole range (' + c.vesa.mount.w[0] + ' to ' + c.vesa.mount.w[1] + ' mm wide, ' + c.vesa.mount.h[0] + ' to ' + c.vesa.mount.h[1] + ' mm tall).');
    else out.push('Hole pattern not checked. Enter both hole spacings above.');
    if (c.weight.ok) out.push(lb1(c.weight.tv) + ' lb of ' + fmt(c.weight.mount) + ' lb rated load.');
    else out.push('We do not have this TV\'s weight. This mount is rated for ' + fmt(c.weight.mount) + ' lb.');
    if (c.size.ok && c.size.railsMax && c.size.tv > c.size.mount[1]) out.push('Made for ' + fmt(c.size.mount[0]) + ' to ' + fmt(c.size.mount[1]) + ' inch screens, and up to ' + fmt(c.size.railsMax) + ' inches ' + (r.rails && r.rails.needed === false ? 'when the distance from the top edge to the lower mounting holes is ' + RAILS_REACH_MM + ' mm or less' : 'with ' + RAILS_NAME) + '. Yours is ' + c.size.tv + ' inches.');
    else if (c.size.ok) out.push('Made for ' + fmt(c.size.mount[0]) + ' to ' + fmt(c.size.mount[1]) + ' inch screens. Yours is ' + c.size.tv + ' inch.');
    else out.push('Screen size not checked. Pick it above.');
    if (r.rails) out.push(railsLine(r));
    return out;
  }

  function answer(kind, res, phone) {
    var tv = res && res.tv;
    if (kind === 'proprietary') {
      return 'This TV uses the maker\'s own mount' + (tv && tv.iface ? ': ' + tv.iface.replace(/\.$/, '') + '.' : '.') + ' A standard VESA mount will not bolt to it, so we are not listing any. ' + callUs(phone) + ' and we can talk it through.';
    }
    if (kind === 'no_vesa') return 'The maker has not published this TV\'s hole pattern. Measure between the four threaded holes on the back, center to center, left to right and top to bottom, and enter both below.';
    if (kind === 'none') return 'Enter the screen size and the hole spacing below and we will check them, or ' + callUs(phone).replace('Call', 'call') + ' and we can look it up.';
    if (kind === 'unavailable') return 'Enter the screen size and the hole spacing below, or try the model number again in a minute.';
    if (kind === 'need_size') return 'Pick your screen size so we can check each mount\'s size range.';
    if (kind === 'zero') {
      var zr = res.zeroReason || (tv && tv.vesaW != null ? 'holes' : 'size');
      if (zr === 'size' || !tv || tv.vesaW == null) return 'None of our mounts is made for a ' + (tv ? tv.sizeIn : '') + ' inch screen. ' + callUs(phone) + ': we customize most ceiling mounts.';
      if (zr === 'weight' && tv.weightLb != null) return 'None of our mounts is rated for a TV that weighs ' + (Math.round(tv.weightLb * 10) / 10) + ' lb. ' + callUs(phone) + ': we customize most ceiling mounts.';
      return 'None of our mounts takes a TV with VESA ' + vesaText(tv) + (tv.weightLb != null ? ' that weighs ' + lb1(tv.weightLb) + ' lb' : '') + '. A VESA adapter plate can bridge a hole pattern a mount does not take. ' + callUs(phone) + ': we customize most ceiling mounts.';
    }
    if (kind === 'hand_error') return 'Enter the width and the height as numbers, for example 400 and 300.';
    if (kind === 'override') return 'Your size differs from our list for this TV, so the builder will use the size you picked.';
    return '';
  }

  function alnum(t) { return String(t == null ? '' : t).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function tvShort(tv) {
    var m = tv && tv.model ? String(tv.model) : '', s = tv && tv.series ? String(tv.series) : '', a = alnum(s);
    return a && /\d/.test(a) && alnum(m).indexOf(a) !== -1 ? s : m;
  }
  function tvName(tv) {
    if (!tv || tv.source !== 'catalog') return '';
    return ((tv.manufacturer ? tv.manufacturer + ' ' : '') + (tv.model || '')).trim();
  }

  var BADGE = {
    fits: function (name) { return name ? 'Fits your ' + name : 'Fits your TV'; },
    fits_hand: 'Fits your figures',
    rails_free: 'Fits with free adapter rails',
    rails: 'Fits with adapter rails',
    check_weight: 'Check the weight',
    check_weight_hand: 'Fits your figures, check the weight',
    size_only: 'Fits your screen size',
    miss: 'Does not fit your TV',
    miss_hand: 'Does not fit your figures',
    size: function (lo, hi) { return 'Made for ' + lo + ' to ' + hi + ' in screens'; }
  };
  var HIDE = { vesa: true, weight: true, size: true };

  function neutral(m) {
    var o = {};
    for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) o[k] = m[k];
    o.type = []; o.component_type = null;
    return o;
  }

  function facts(r, tv) {
    var c = r.checks, out = [], v = c.vesa, w = c.weight, z = c.size;
    if (!v || !w || !z) return out;
    var hand = !!tv && tv.source !== 'catalog';
    if (!v.mount) out.push('This mount has no hole range listed.');
    else if (!v.tv) out.push('Hole pattern not checked.');
    else out.push(fmt(snapVesa(v.tv[0])) + ' x ' + fmt(snapVesa(v.tv[1])) + ' mm is ' + (v.ok ? 'inside' : 'outside') + ' this mount\'s hole range (' + v.mount.w[0] + ' to ' + v.mount.w[1] + ' mm wide, ' + v.mount.h[0] + ' to ' + v.mount.h[1] + ' mm tall).');
    if (w.mount == null) out.push('This mount has no weight rating listed.');
    else if (w.tv == null) out.push(hand ? 'Check your TV\'s weight against this mount\'s ' + fmt(w.mount) + ' lb rating.' : 'We do not have this TV\'s weight. This mount is rated for ' + fmt(w.mount) + ' lb.');
    else out.push(lb1(w.tv) + ' lb ' + (w.ok ? 'of ' + fmt(w.mount) + ' lb rated load.' : 'is more than this mount\'s ' + fmt(w.mount) + ' lb rating.'));
    if (!z.mount) out.push('This mount has no screen size range listed.');
    else {
      var made = 'Made for ' + fmt(z.mount[0]) + ' to ' + fmt(z.mount[1]) + ' inch screens' + (z.railsMax && z.railsMax > z.mount[1] ? ', and up to ' + fmt(z.railsMax) + ' inches with our adapter rails' : '') + '.';
      out.push(z.tv == null ? made : made + ' Yours is ' + z.tv + ' inches.');
    }
    if (r.rails) out.push(railsLine(r));
    if (hand) out.push('Checked from your figures.');
    return out;
  }

  function verdict(tv, m, r) {
    r = r || checkMount(tv, m);
    var hand = !!tv && tv.source !== 'catalog', c = r.checks;
    var out = { fit: r.fit, reason: r.reason, kind: 'none', badge: null, hide: false, vesaOk: c.vesa ? c.vesa.ok : null, facts: [] };
    if (tv && tv.source === 'catalog' && tv.state !== 'ok') {
      out.vesaOk = null;
      out.facts = tv.state === 'proprietary' ? ['This TV uses the maker\'s own mount. A standard VESA mount will not bolt to it.'] : facts(r, tv);
      return out;
    }
    if (r.fit === 'fits' || r.fit === 'fits_rails') {
      out.kind = 'fit';
      out.badge = r.fit === 'fits_rails' ? (r.rails && r.rails.free === true ? BADGE.rails_free : BADGE.rails) : hand ? BADGE.fits_hand : BADGE.fits(tv.source === 'catalog' ? tv.model : null);
    } else if (r.fit === 'check_weight' || r.fit === 'size_only') {
      out.kind = 'check';
      out.badge = r.fit === 'size_only' ? BADGE.size_only : hand ? BADGE.check_weight_hand : BADGE.check_weight;
    } else if (HIDE[r.reason]) {
      out.kind = 'miss';
      out.badge = r.reason === 'size' ? BADGE.size(fmt(c.size.mount[0]), fmt(c.size.mount[1])) : hand ? BADGE.miss_hand : BADGE.miss;
      out.hide = !(hand && (tv.vesaW == null || tv.vesaH == null));
    }
    if (r.reason === 'part') {
      var q = checkMount(tv, neutral(m || {}));
      out.vesaOk = q.checks.vesa ? q.checks.vesa.ok : null;
      out.facts = facts(q, tv);
    } else out.facts = facts(r, tv);
    return out;
  }

  function barParts(tv) {
    if (!tv) return [];
    var p = [];
    if (tv.source === 'catalog') p.push(((tv.manufacturer ? tv.manufacturer + ' ' : '') + (tv.model || '')).trim());
    else if (tv.source === 'manual') p.push('Your measurements', nice(tv.a) + ' in tall');
    else p.push('Your TV');
    if (tv.vesaW != null && tv.vesaH != null) p.push('VESA ' + vesaText(tv));
    if (tv.weightLb != null) p.push(lb1(tv.weightLb) + ' lb' + (tv.weightKg != null ? ' (' + lb1(tv.weightKg) + ' kg)' : ''));
    if (tv.sizeIn != null) p.push(tv.sizeIn + ' in');
    return p;
  }

  root.VMSMountFit = {
    tvFromRow: tvFromRow, tvFromParams: tvFromParams, matchGroup: matchGroup, subType: subType, checkMount: checkMount,
    matchAll: matchAll, expand: expand, snapVesa: snapVesa, parseVesa: parseVesa, pageParams: pageParams, builderLink: builderLink,
    nice: nice, SUBS: SUBS, isRailsMount: isRailsMount, railsUrl: railsUrl, verdict: verdict, tvName: tvName, tvShort: tvShort, BADGE: BADGE,
    RAILS: { alwaysBig: RAILS_ALWAYS_71_75, sku: RAILS_MOUNT_SKU, reachMm: RAILS_REACH_MM, maxIn: RAILS_MAX_IN, handle: RAILS_HANDLE },
    copy: { sentence: sentence, twoTvNote: twoTvNote, lines: lines, answer: answer, barParts: barParts, railsLine: railsLine, railsVerdict: railsVerdict, railsProperty: railsProperty }
  };
})(window);
